import { Partaker } from '@grupo-constant/next-dtype/types';
import { UploadMasterXSSFResponse } from '../master-data/master-data.types';
import { LocaleString } from '../translate/localeString.model';
import { TaskSearch, UploadTaskModelResponse } from '../../modules/admin/tasks/tasks.types';
import { SearchWorkshiftElement, WorkshiftUserEventSummary } from '../../modules/admin/workshifts/workshifts.types';

export enum WebSocketTypeEnum {
    CACHE_UPDATE = 'CACHE_UPDATE',
	CACHE_REMOVE = 'CACHE_REMOVE',
	CACHE_RELOAD = 'CACHE_RELOAD',
	CACHE_UPDATE_DN = 'CACHE_UPDATE_DN',
	CACHE_REMOVE_DN = 'CACHE_REMOVE_DN',
	CACHE_RELOAD_DN = 'CACHE_RELOAD_DN',
	TASK_ROW_UPDATE = 'TASK_ROW_UPDATE',
    WORKSHIFT_ROW_UPDATE = 'WORKSHIFT_ROW_UPDATE',
    WORKSHIFT_USER_EVENT_UPDATE = 'WORKSHIFT_USER_EVENT_UPDATE',
	MASTER_ASYNC_UPLOADED = 'MASTER_ASYNC_UPLOADED',
    TASKS_ASYNC_UPLOADED = 'TASKS_ASYNC_UPLOADED',
    GENERIC_ALERT = 'GENERIC_ALERT',
    SYSTEM_CHANGES = 'SYSTEM_CHANGES',
    DAILY_TASK_UPDATE = 'DAILY_TASK_UPDATE',
    PREMISES_HOTEL_WORK_UPDATE = 'PREMISES_HOTEL_WORK_UPDATE',
    PREMISES_HOTEL_DAILY_UPDATE = 'PREMISES_HOTEL_DAILY_UPDATE',
    PREMISES_CENTER_WORK_UPDATE = 'PREMISES_CENTER_WORK_UPDATE',
    PREMISES_GENERIC_WORK_UPDATE = 'PREMISES_GENERIC_WORK_UPDATE',
    WORKPLACE_BILLING_AUTOMATION_CONFIG = 'WORKPLACE_BILLING_AUTOMATION_CONFIG',
    PREMISES_GENERIC_ACTIVITY_TYPE_OBJECTIVE_LIST_UPDATE = 'PREMISES_GENERIC_ACTIVITY_TYPE_OBJECTIVE_LIST_UPDATE'
}

export interface WebSocketMessage {
    type: WebSocketTypeEnum;
    payload: any;
}

export interface WebSocketGenericMessage extends WebSocketMessage {
    receivedDate: string;
}
export interface GenericAlertConfig {
    alertType: GenericAlertType;
	dismissible: boolean;
	showIcon: boolean;
	alertTitle: LocaleString;
	alertText: LocaleString;
	downloadFile: string;
}

export enum GenericAlertType {
    info = 'info',
	success = 'success',
	warning = 'warning',
	error = 'error'
}

export interface WebSocketTaskRowUpdateMessage {
    row: TaskSearch;
    partaker: Partaker;
}

export interface WebSocketWorkshiftRowUpdateMessage {
    row: SearchWorkshiftElement;
    partaker: Partaker;
}

export interface WebSocketWorkshiftUserEventUpdateMessage {
    summaryByWorkshift: WorkshiftUserEventSummary;
    daySummary: WorkshiftUserEventSummary;
    workplaceCode: string;
    workshiftId: string;
    userId: string;
    partaker: Partaker;
}

export interface WebSocketMasterAsyncUpdated {
    userId?: string;
    uri?: string;
    reply?: UploadMasterXSSFResponse;
}

export interface WebSocketTasksAsyncUpdated {
    userId?: string;
    serviceId?: string;
    reply?: UploadTaskModelResponse;
}
